// extracted by mini-css-extract-plugin
export var accent = "_7f-4";
export var add = "_7f-j";
export var addIcon = "_7f-k";
export var deleteIcon = "_7f-i";
export var disabled = "_7f-9";
export var ellipsis = "_7f-f";
export var error = "_7f-3";
export var form = "_7f-5";
export var hideFocus = "_7f-2";
export var icon = "_7f-7";
export var input = "_7f-e";
export var listItem = "_7f-h";
export var mediumHeight = "_7f-b";
export var noBorder = "_7f-8";
export var noRadius = "_7f-1";
export var shortHeight = "_7f-a";
export var tallHeight = "_7f-c";
export var textInput = "_7f-0";
export var vertical = "_7f-g";
export var veryTallHeight = "_7f-d";
export var widget = "_7f-6";